import Image from 'next/image';
import { ComponentPropsWithoutRef } from 'react';

type CertificateLabelProps = ComponentPropsWithoutRef<'div'> & {
  certificateShortName: string;
};

const CertificateLabel = (props: CertificateLabelProps) => {
  const { certificateShortName, className } = props;

  const finalClassName = `${className} inline-flex items-center gap-2 px-[8px] py-[4px] rounded-xl bg-[#328B1C] text-white font-[500px] text-[14px]`;

  return (
    <div className={finalClassName}>
      <Image alt="badge" src="/icons/badge-check.svg" width={20} height={20} />
      <span>Cấp chứng chỉ {certificateShortName}</span>
    </div>
  );
};
export default CertificateLabel;
